module.exports = __webpack_public_path__ + "static/img/SIMCOE.5b9e0c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/SIMCOE.jpg
// module id = jU4g
// module chunks = 0